export const validarCnpj = (cnpj: string | undefined, required: boolean = false): boolean => {
  if (!cnpj) return !required;

  // CNPJ alfanumérico: 12 posições alfanuméricas (A-Z, 0-9) + 2 dígitos verificadores numéricos.
  // Mesmo algoritmo módulo-11, usando o valor ASCII de cada caractere menos 48
  // ('0'..'9' => 0..9, 'A'..'Z' => 17..42), compatível com o CNPJ numérico legado.
  const valor = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (!/^[A-Z0-9]{12}\d{2}$/.test(valor)) return false;

  const valorCaractere = (caractere: string) => caractere.charCodeAt(0) - 48;

  const calcularDigito = (base: string, pesos: number[]) => {
    let soma = 0;
    for (let i = 0; i < pesos.length; i++) {
      soma += valorCaractere(base[i]) * pesos[i];
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const base = valor.slice(0, 12);
  const primeiroDigito = calcularDigito(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const segundoDigito = calcularDigito(`${base}${primeiroDigito}`, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

  return Number(valor[12]) === primeiroDigito && Number(valor[13]) === segundoDigito;
};
